// extracted by mini-css-extract-plugin
module.exports = {"container":"productHead_container__1LDKn","title":"productHead_title__3633r","lineYellow":"productHead_lineYellow__1GDcT","priceSection":"productHead_priceSection__9YE7a","dollar":"productHead_dollar__3ckvq","price":"productHead_price__34UG4","smallPrice":"productHead_smallPrice__D6hb5","smallDollar":"productHead_smallDollar__2UYFE","month":"productHead_month__iRpbL","text":"productHead_text__1UXmi","contentLinePrice":"productHead_contentLinePrice__28puT"};
    if(module.hot) {
      // 1790670319382
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  